import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory, useLocation } from 'react-router-dom';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import FolderIcon from '@material-ui/icons/Folder';
import ViewComfyIcon from '@material-ui/icons/ViewComfy';
import ViewCompactIcon from '@material-ui/icons/ViewCompact';
import ViewColumnIcon from '@material-ui/icons/ViewColumn';
import ImportExportIcon from '@material-ui/icons/ImportExport';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import QueryStatsIcon from '@material-ui/icons/BubbleChart';
import clsx from 'clsx';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';

import ListItemText from '@material-ui/core/ListItemText';
import MapIcon from '@material-ui/icons/Map';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    borderBottom: '2px solid black',
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
}));

const menu = [
  {
    text: 'Карта полів',
    icon: <MapIcon />,
    link: '/fields',
  },
  {
    text: 'Редактор полей',
    icon: <ViewComfyIcon />,
    link: '/fields-editor',
  },
  {
    text: 'Поля',
    icon: <ViewCompactIcon />,
    link: '/field-viewer',
  },
  {
    text: 'Земельный участки',
    icon: <ViewColumnIcon />,
    link: '/shares',
  },
  {
    text: 'Контрагенты',
    icon: <PeopleAltIcon />,
    link: '/contractors',
  },
  {
    text: 'Договора',
    icon: <FolderIcon />,
    link: '/contracts',
  },

  {
    text: 'Статистика',
    icon: <QueryStatsIcon />,
    link: '/contractors',
  },
  {
    text: 'Импорт/Експорт',
    icon: <ImportExportIcon />,
    link: '/debug',
  },
];

export function Bar() {
  const location = useLocation();
  const history = useHistory();
  const classes = useStyles();

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === 'top' || anchor === 'bottom',
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        {menu.map(({ text, icon, link }, index) => (
          <ListItem
            disabled={location.pathname === link ? true : false}
            button
            key={text}
            onClick={() => history.push(link)}
          >
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>
      <Divider />
    </div>
  );

  return (
    <div className={classes.root}>
      <AppBar position="static" color="transparent" style={{ backgroundColor: '#43a047' }}>
        <Toolbar>
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="menu"
            onClick={toggleDrawer('left', true)}
          >
            <MenuIcon style={{ color: 'white' }} />
          </IconButton>
          <Typography variant="h6" className={classes.title} style={{ color: 'white' }}>
            AGRO.UNIT (Земельный банк)
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer anchor={'left'} open={state['left']} onClose={toggleDrawer('left', false)}>
        {list('left')}
      </Drawer>
    </div>
  );
}
